import {styled} from '@mui/material'
import {Texts} from 'appearance'
import {Controller} from 'react-hook-form'
import {orientationStyles} from 'services/utils/formUtils'
import {imageToBase64} from 'services/utils/misc'
import {FormErrorText} from '.'
import ImageUploadInput from '../ImageUploadInput'
import {useDeviceDetect} from 'services/hooks'

const FormImageUpload = ({
    name,
    label,
    LabelComponent,
    control,
    formErrors,
    required,
    rules,
    type,
    disabled,
    orientation = 'horizontal',
    readOnly,
    InputProps,
    editMode = true,
    ...p
}) => {
    const {isMobile} = useDeviceDetect()
    return (
        <Container style={orientationStyles[orientation]}>
            {LabelComponent ? (
                <LabelComponent />
            ) : (
                <Label isMobile={isMobile}>{label}</Label>
            )}
            <Controller
                name={name}
                control={control}
                rules={rules || {required}}
                render={({field: {onChange, value}}) =>
                    editMode && !readOnly ? (
                        <ImageUploadInput
                            onChange={async (e) => {
                                const base64Image = await imageToBase64(
                                    e.target.files[0]
                                )
                                onChange(base64Image)
                            }}
                            // value={value}
                            fullWidth={true}
                            required={required}
                            disabled={disabled}
                            InputProps={InputProps}
                            style={{flex: 3}}
                            {...p}
                        />
                    ) : (
                        // <Value>{value?.slice(0, 10) || ''}</Value>
                        <Value>
                            <UploadedImage src={value} />
                        </Value>
                    )
                }
            />
            {formErrors?.[name] && (
                <FormErrorText>{formErrors?.[name]?.message}</FormErrorText>
            )}
        </Container>
    )
}

export default FormImageUpload

const Container = styled('div')`
    display: flex;
`

const Label = styled(Texts.BoldText)`
    font-size: ${({isMobile}) => (isMobile ? 14 : 18)}px;
    flex: 1;
`
const Value = styled('View')`
    flex: 4;
`

const UploadedImage = styled('img')`
    /* width: 100px; */
    max-width: 200px;
    flex: 4;
    /* height: 200px; */
`
